module.exports = __webpack_public_path__ + "static/media/learn.208f8744.svg";